import {twMerge} from '@sdox/utils'

import styles from './dialogSection.module.scss'

import type {ComponentProps} from 'react'

export const DialogSection = ({children, className, ...restProps}: ComponentProps<'div'>) => (
  <div
    className={twMerge('flex-1 p-5 sm:px-12 sm:pb-12', styles.dialogHtml, className)}
    {...restProps}
  >
    {children}
  </div>
)
